module.exports = __webpack_public_path__ + "media/puzzle4_9.e22d735b.mp3";